<template>
  <div class="bg-grey-100 flex justify-center items-center h-screen">
    <empty-listing-state
      :responsive="true"
      :empty_state_image="'icons/success-icon.png'"
      :empty_state_image_width="80"
      :empty_state_heading="'frontend_groovemail_form_submission_success_heading'"
      :empty_state_sub_heading="'frontend_groovemail_form_submission_success_sub_heading'"
      :empty_state_button_text="false"
    ></empty-listing-state>
  </div>
</template>

<script>
import EmptyListingState from '@/components/empty-listing-state.vue';

export default {
  layout: 'iframeLayout',

  metaInfo() {
    return { title: this.$t('frontend_groovemail_form_submission_success_page') };
  },
  
  data() {
    return {};
  },

  components: {
    EmptyListingState,
  },
};
</script>
